import React from "react";
import Home from "./pages/Home";
import History from "./pages/History"; // ⬅️ PAGE الجديدة
import { AppProvider } from "./contexts/AppContext";
import Header from "./components/Header";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <AppProvider>
      <Router>
         <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/history" element={<History />} />
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;
